import React from "react";


const ButtonTag = (props) => {
  const { name, classes } = props;

  return (
    <button
      onClick={props.onSubmit}
      type="submit"
      className={`${classes} cursor-pointer font-popinsMedium rounded-md flex justify-center mx-auto py-2 w-full`}
    >
      {name}
    </button>
  );
}

export default ButtonTag;
